import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/Ucollection.css";
import apiService from "../../../ApiServices/ApiServices";

const Ucollection = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchProducts();
    window.scrollTo(0, 0);
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await apiService.get(process.env.REACT_APP_API_URL, {
        params: {
          brand_id: 1, // Brand-wise filter
          // category_id: 1,
          limit: 3, // Fetch only three products
          page: 1,
        },
      });
      setProducts(response.data.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleShopClick = () => {
    navigate("/umadras/collections");
  };
  const handleProductClick = (id) => {
    navigate('/umadras/collections');
  };


  return (
    <div className="collection-container" id="collection">
      <h2 className="collection-title">Collection</h2>
      <div className="collection-grid">
        {products.length > 0 ? (
          products.map((product) => (
            <div key={product.id} className="collection-item">
              <div className="product-details">
                <img
                  src={`https://admin.utharamenon.com/storage/${product.product_images[0]?.image_url}`}
                  alt={product.name}
                  className="ucollection-image"
                  onClick={() => handleProductClick(product.id)}
                  style={{ cursor: "pointer" }}
                />
                </div>
                <div className="product-title">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">Rs. {product.price}</p>
                </div>
            </div>
          ))
        ) : (
          <p className="no-products">No products available</p>
        )}
      </div>
      <button className="shop-button" onClick={handleShopClick}>
        Shop Collection &gt;
      </button>
    </div>
  );
};

export default Ucollection;
